import React from 'react';
import dropdownStyle from './dropDownStyle';
import { Button } from 'react-bootstrap';
import Select from 'react-select';

// styled components
const Menu = ({ width = '160px', ...rest }) => {
  const shadow = 'hsla(218, 50%, 10%, 0.1)';
  return (
    <div
      style={{
        position: 'absolute',
        backgroundColor: 'white',
        borderRadius: 4,
        minWidth: width, // Menu max width
        boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
        marginTop: 8,
        zIndex: 2,
      }}
      {...rest}
    />
  );
};
const Blanket = props => (
  <div
    style={{
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: 'fixed',
      zIndex: 1,
    }}
    {...props}
  />
);

const Dropdown = ({ children, isOpen, target, onClose, menuWidth }) => (
  <div style={{ position: 'relative' }}>
    {target}
    {isOpen ? <Menu width={menuWidth} >{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);

const Svg = p => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    focusable="false"
    role="presentation"
    {...p}
  />
);

const DropdownIndicator = () => (
  <div style={{ color: '#ddd', height: 24, width: 32 }}>
    <Svg>
      <path
        d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Svg>
  </div>
);

class Popout extends React.Component {
  state = { isOpen: false };

  toggleOpen = () => {
    this.setState(state => ({ isOpen: !state.isOpen }));
  };

  onSelectChange = value => {
    this.toggleOpen();
    this.props.onChange(value);
  };

  getTitle = (value) => {
    const {
      name = '',
      maxDisplay = 3,
      isMulti,
      title,
    } = this.props;
    if (!isMulti && value) return `${value.label}`;
    if (value && value.length > 0 && value.length <= maxDisplay)
      return value.reduce((acc, current) => `${acc ? `${acc}, ` : acc}${current.label}`, '')
    if (value && value.length > maxDisplay)
      return `Selecionado: ${value.length} ${name}${value.length > 1 ? `${name ? "s" : ""}` : ''}`
    return title || `Selecione um(a) ${name}`;
  }

  render() {
    const { isOpen } = this.state;
    const { value, buttonStyle, menuWidth, Component = Select, ...rest } = this.props;
    const title = this.getTitle(value);
    return (
      <Dropdown
        isOpen={isOpen}
        onClose={this.toggleOpen}
        menuWidth={menuWidth}
        target={
          <Button
            style={buttonStyle}
            onClick={this.toggleOpen}
            // isSelected={isOpen}
          >
            {title}
          </Button>
        }
      >
        <Component
          autoFocus
          backspaceRemovesValue={false}
          components={{ DropdownIndicator, IndicatorSeparator: null }}
          controlShouldRenderValue={false}
          hideSelectedOptions={false}
          menuIsOpen
          onChange={this.onSelectChange}
          placeholder="Search..."
          styles={dropdownStyle}
          tabSelectsValue={false}
          value={value}
          {...rest}
        />
      </Dropdown>
    );
  }
}

export default Popout;
